import { PaletteColor, Stack, Typography } from "@mui/material";
import compInfos from "./sidebar.json";
import { useLangContext } from "../../../context/langContext";

export default function SidebarComponent() {
  const { lang, dir } = useLangContext();
  const infos = lang == "en" ? compInfos.en : compInfos.fa;
  return (
    <Stack
      dir={dir}
      alignItems="center"
      justifyContent="center"
      height="95%"
      sx={{
        background: ({ palette }) => palette.accent[700],
        borderBottomLeftRadius: dir === "ltr" ? "132px" : "0",
        borderBottomRightRadius: dir === "rtl" ? "132px" : "0",
      }}
    >
      <Stack
        direction="column"
        alignItems="center"
        justifyContent="center"
        color={(theme) => theme.palette.others?.bg}
        width="50%"
      >
        <Typography
          variant="footerDemiBold"
          sx={{
            mb: "26px",
          }}
        >
          {infos.title}
        </Typography>
        <Typography
          variant="labelMediumBold"
          sx={{
            textAlign: "center",
          }}
        >
          {infos.description}
        </Typography>
      </Stack>
    </Stack>
  );
}
